import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { SchwerbehinderungsGrad } from '../../../../db/enums/misc-enums.js';
import { ZipCity } from '../../../../db/zip-city.js';

@Entity()
export class ANSchwerbehinderung extends AdornisEntity {
  static override _class = 'ANSchwerbehinderung';

  @Field(() => Boolean, { default: v => v ?? false })
  istVorhanden: Maybe<boolean>;

  @Field(() => String)
  grad: Maybe<SchwerbehinderungsGrad>;

  @Field(() => String)
  dienststelle: Maybe<string>;

  @Field(() => ZipCity, { default: v => v ?? new ZipCity({}) })
  dienststelleZip: Maybe<ZipCity>;

  @Field(() => Date)
  gueltigVon: Maybe<Date>;

  @Field(() => Date)
  gueltigBis: Maybe<Date>;

  @Field(() => String)
  kennzeichnung: Maybe<string>;

  @Field(() => ID)
  schwerbehinderungID: Maybe<string>;
}
